import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import { Label } from '../../../../shared/compass-ui'
import ControlledSelect from '../../../shared/ControlledSelect'
import ControlledTextInput from '../../../shared/ControlledTextInput'
import TextInputError from '../../../shared/TextInputError'
import HiddenFieldMirror from '../../../shared/HiddenFieldMirror'

const DEGREE_TYPE_OPTIONS = [
  { label: 'High School / GED', value: 'high_school' },
  { label: 'Associate Degree', value: 'associate' },
  { label: "Bachelor's Degree", value: 'bachelors' },
  { label: "Master's Degree", value: 'masters' },
  { label: 'Doctorate', value: 'doctorate' },
  { label: 'Other', value: 'other' },
]

const FIELD_OF_STUDY_OPTIONS = [
  { label: 'Agriculture / Environmental Science', value: 'agriculture' },
  { label: 'Architecture / Urban Planning', value: 'architecture' },
  { label: 'Arts / Design / Performing Arts', value: 'arts' },
  { label: 'Biology / Life Sciences', value: 'biology' },
  { label: 'Business / Management', value: 'business' },
  { label: 'Chemistry / Physics', value: 'chemistry' },
  { label: 'Communications / Journalism', value: 'communications' },
  { label: 'Computer Science / IT', value: 'computer_science' },
  { label: 'Criminal Justice / Law Enforcement', value: 'criminal_justice' },
  { label: 'Culinary Arts / Hospitality', value: 'culinary' },
  { label: 'Economics', value: 'economics' },
  { label: 'Education / Teaching', value: 'education' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'English / Literature / Writing', value: 'english' },
  { label: 'Finance / Accounting', value: 'finance' },
  { label: 'Health Sciences / Nursing', value: 'health_sciences' },
  { label: 'History / Political Science', value: 'history' },
  { label: 'Law / Pre-Law', value: 'law' },
  { label: 'Liberal Arts / General Studies', value: 'liberal_arts' },
  { label: 'Mathematics / Statistics', value: 'mathematics' },
  { label: 'Medicine / Pre-Med', value: 'medicine' },
  { label: 'Philosophy / Religion', value: 'philosophy' },
  { label: 'Psychology', value: 'psychology' },
  { label: 'Social Work / Human Services', value: 'social_work' },
  { label: 'Sociology / Anthropology', value: 'sociology' },
  { label: 'Trade / Vocational Program', value: 'trade' },
  { label: 'Undecided / Exploratory', value: 'undecided' },
  { label: 'Other', value: 'other' },
]

const StudentDetails: FC = () => {
  const {
    formState: {
      errors: {
        degreeType: degreeTypeError,
        institution: institutionError,
        fieldOfStudy: fieldOfStudyError,
      },
    },
    clearErrors,
  } = useFormContext()

  return (
    <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-6">
      <HiddenFieldMirror name="degreeType" />
      <HiddenFieldMirror name="fieldOfStudy" />
      <div>
        <ControlledSelect
          id="degree-type-select"
          name="degreeType"
          label={EXTRA_QUESTION_LABELS.degreeType}
          options={DEGREE_TYPE_OPTIONS}
          error={typeof degreeTypeError?.message === 'string'}
          errorId="degreeType-error"
          registerOptions={{
            onChange: () => {
              if (degreeTypeError) clearErrors('degreeType')
            },
          }}
        />
        {typeof degreeTypeError?.message === 'string' && (
          <TextInputError id="degreeType-error">This field is required</TextInputError>
        )}
      </div>
      <div>
        <Label htmlFor="institution-input">{EXTRA_QUESTION_LABELS.institution}</Label>
        <ControlledTextInput name="institution" id="institution-input" />
        {typeof institutionError?.message === 'string' && (
          <TextInputError>This field is required</TextInputError>
        )}
      </div>
      <div>
        <ControlledSelect
          id="field-of-study-select"
          name="fieldOfStudy"
          label={EXTRA_QUESTION_LABELS.fieldOfStudy}
          options={FIELD_OF_STUDY_OPTIONS}
          error={typeof fieldOfStudyError?.message === 'string'}
          errorId="fieldOfStudy-error"
          registerOptions={{
            onChange: () => {
              if (fieldOfStudyError) clearErrors('fieldOfStudy')
            },
          }}
        />
        {typeof fieldOfStudyError?.message === 'string' && (
          <TextInputError id="fieldOfStudy-error">This field is required</TextInputError>
        )}
      </div>
    </div>
  )
}

export default StudentDetails
